import React from 'react'
import { SearchIcon } from '@myxplor/icons'
import classnames from 'classnames'
import './filter.css'

const FilterList = ({ show, term, onChange }) => (
  show ?
    <form
      className={classnames({
        'listFilter': true,
        'layoutPosition--sticky': true,
        'listFilter__filtering': term,
      })}
      onSubmit={e => e.preventDefault()}
      autoComplete="off"
    >
      <label htmlFor="filter-term">
        {term ? 'Filtering' : 'Filter'}
      </label>

      <div className="listFilter--inputs">
        <SearchIcon className="listFilter--icon" />
        <input
          type="search"
          name="filter-term"
          id="filter-term"
          placeholder="Type to filter"
          defaultValue={term}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </form>
    : null
)

export default FilterList


// WEBPACK FOOTER //
// ./src/ui/list/views/filter.jsx